import { useState } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { PostalAddressForm as PostalAddressFormDumb } from '#src/components/settings/PostalAddressForm/index.tsx';
import { SettingsSection } from '#src/components/settings/SettingsSection/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

import { useDeleteUserPostalAddress } from './useDeleteUserPostalAddress.tsx';
import { useUpdateUserPostalAddress } from './useUpdateUserPostalAddress.tsx';

const ButtonWrapper = styled.div`
  display: flex;
  gap: var(--unit);
  justify-content: flex-end;
`;
const messages = defineMessages({
  title: {
    defaultMessage: 'Postal address',
  },
});

export const PostalAddress = () => {
  const { deleteUserPostalAddress } = useDeleteUserPostalAddress();
  const [key, setKey] = useState(0);
  const updateUserPostalAddress = useUpdateUserPostalAddress();
  return (
    <SettingsSection title={messages.title}>
      <PostalAddressFormDumb
        // Use key to reset the form when the user delete his address
        key={key}
        onSubmit={(attributes, onResult, onCancel) => {
          updateUserPostalAddress(attributes).then(onResult).catch(onCancel);
        }}
        onSuccess={() => {}}
        button={SubmitButton => (
          <ButtonWrapper>
            <Button
              color="red"
              size="small"
              onClick={async () =>
                deleteUserPostalAddress().then(() => setKey(k => k + 1))
              }
            >
              <FormattedMessage {...glossary.delete} />
            </Button>
            <SubmitButton size="small">
              <FormattedMessage {...glossary.update} />
            </SubmitButton>
          </ButtonWrapper>
        )}
      />
    </SettingsSection>
  );
};
